var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "button",
    {
      staticClass: "btn btn--link",
      attrs: { disabled: _vm.downloading },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.download.apply(null, arguments)
        },
      },
    },
    [
      _c("SvgIcon", { attrs: { icon: "link" } }),
      _vm._v(" "),
      _vm.downloading ? _c("span", [_vm._v("Downloading...")]) : _vm._e(),
      _vm._v(" "),
      _c("span", { domProps: { textContent: _vm._s(_vm.buttonTitle) } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }